<template>
    <button :class="['simple_button', { 'disabled_button': disabled },
        { 'empty_classification_button': clasificar },
        classification ? [getButtonStyle(classiValue), 'classi_button', skew(classiValue)] : '']"
        :style="computedStyle" @click="onButtonClick()">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: "SimpleButton",
    data() {
        return {
            buttonStyles: ['b-red', 'b-blue', 'b-yellow', 'b-green', 'b-brown', 'b-orange', 'b-pink'],
            skew_styles: ['skew_box_1', 'skew_box_2', 'skew_box_3', 'skew_box_4', 'skew_box_5'],
        };
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        buttonStyle: {
            type: String,
            default: '',
        },
        clasificar: {
            type: Boolean,
            default: false,
        },
        classiValue: {
            type: String,
            default: '',
        },
    },
    computed: {
        computedStyle() {
            return !this.disabled ? { backgroundImage: this.buttonStyle } : {};
        },
        classification() {
            return this.classiValue != '';
        }
    },
    methods: {
        getNumberFromName(name, list) {
            const asciiSum = name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
            const styleIndex = asciiSum % list.length;
            return styleIndex;
        },
        getButtonStyle(name) {
            const styleIndex = this.getNumberFromName(name, this.buttonStyles);
            return this.buttonStyles[styleIndex];
        },
        skew(name) {
            const styleIndex = this.getNumberFromName(name, this.skew_styles);
            return this.skew_styles[styleIndex];

        },
        onButtonClick() {
            if (this.disabled) {
                return;
            }
            this.$emit('click');
        },
    },
};
</script>
<style scoped>
.disabled_button {
    background-color: #eee;
    padding: 0.01em 1em 0.01em 0.7em;
    margin: 1px 0 1px 0;
    border: none;
    border-radius: 1px;
    font-weight: bold;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.disabled_button:hover {
    background-color: #eee;
}

.simple_button {
    cursor: pointer;
    padding: 0.01em 1em 0.01em 0.7em;
    margin: 1px 0 1px 0;
    border: 1px solid #c0c0ff38;
    border-radius: 1px;
    font-weight: bold;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
    transition: background-color 0.07s, transform 0.07s, filter 0.07s;
    padding-top: 2px;
    padding-bottom: 2px;
}

.simple_button:hover:after {
    content: '';
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, .2);
}

.simple_button:hover {
    padding-top: 0px;
    padding-bottom: 3px;
    filter: brightness(1.2);
    transform: translateY(-1px);
    filter: drop-shadow(2px 2px 4px rgb(181, 181, 181));
}

.simple_button:active {
    background-color: #ccf;
    transform: translateY(1px);
}

.empty_classification_button {
    border-radius: 2px;
    padding: 0 2px 0 2px;
    border: 3px outset #f66;
}

.classi_button {
    flex: 0 1 auto;
    white-space: nowrap;
    font-weight: 100 !important;
    padding: 1px 4px 1px 4px !important;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.classi_button:hover {
    padding-top: 0px;
    padding-bottom: 1px;
    filter: brightness(1.05);
    font-weight: 100 !important;
}

.b-red {
    color: black;
    border-right: 3px solid rgb(248, 175, 175);
    border-bottom: 3px solid rgb(199, 136, 136);
    background-color: #eeeeee;
}

.b-blue {
    color: black;
    border-right: 3px solid rgb(181, 181, 254);
    border-bottom: 3px solid rgb(145, 145, 204);
    background-color: #eeeeee;
}

.b-green {
    color: black;
    border-right: 3px solid rgb(100, 255, 100);
    border-bottom: 3px solid rgb(82, 219, 82);
    background-color: #eeeeee;
}

.b-brown {
    color: black;
    border-right: 3px solid rgb(227, 155, 165);
    border-bottom: 3px solid rgb(199, 132, 141);
    background-color: #eeeeee;
}

.b-orange {
    color: black;
    background-color: #eeeeee;
    border-right: 3px solid rgb(254, 211, 130);
    border-bottom: 3px solid rgb(221, 183, 111);
}

.b-yellow {
    color: black;
    border-right: 3px solid rgb(249, 249, 164);
    border-bottom: 3px solid rgb(219, 219, 148);
    background-color: #eeeeee;

}

.b-pink {
    color: black;
    border-right: 3px solid pink;
    border-bottom: 3px solid rgb(204, 149, 158);
    background-color: #eeeeee;
}

.skew_box_1 {
    transform: skew(0.58deg, 0.58deg);
}

.skew_box_2 {
    transform: skew(-0.58deg, 0.58deg)
}

.skew_box_3 {
    transform: skew(0.58deg, -0.58deg)
}

.skew_box_4 {
    transform: skew(-0.58deg, -0.58deg)
}

.skew_box_5 {
    transform: skew(0deg, -0.58deg)
}

.skew_box_6 {
    transform: skew(0.58deg, 0deg)
}

.skew_box_7 {
    transform: skew(0.58deg, 0deg)
}
</style>